import { Loader2 } from 'lucide-react';

/** Spinner plein écran affiché pendant le chargement des chunks lazy. */
export function LoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}
